import React from 'react';
import Keyword from './Keyword';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';

const HighRiskKeywordsModal = ({data, setVisible}) => {

  return (
    <Modal isOpen={true}
           onClose={() => setVisible(false)}
           className="modal--large modal--full-height modal--short">
      <div className='modal'>
        <div className="modal__header">
          <h3 className="margin-none">
            High Risk Keywords
          </h3>
          <ModalCloseButton
            onClick={() => setVisible(false)}
            label="Close keywords modal"
          />
        </div>

        <div className="modal__body">
          <div className="site-overview site-overview--keywords-modal">
            <div className="keyword-container">
              {data.map((keyword) => {
                return (
                  <Keyword
                    key={keyword.text}
                    text={keyword.text}
                    number={keyword.number}
                    riskLevel={keyword.riskLevel}
                    expanded
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default HighRiskKeywordsModal;
